import React from 'react';
import { useSelector } from 'react-redux';

import { StockDescriptor } from '../../../lib/models/stock-descriptor';
import { isSymbolInFavourites } from '../../../lib/store/helpers';
import { RootState } from '../../../lib/store/index';
import { SymbolLite } from '../../../lib/store/market-data/types';
import { getFavoriteStocks } from '../../../lib/store/selectors';

import StockRow from '../../StocksResult/componets/StockRow';
import AddToWatchlist from '../../SymbolDetailsHeader/components/AddToWatchList';

import styles from './ResultRow.module.scss';

type Props = {
    stock: StockDescriptor
    logo?: string;
    url?: string;
    addToFavourites: () => void;
    closeModal: () => void;
}

const ResultRow = ({ logo, stock, url, addToFavourites, closeModal }: Props) => {
  const favourites = useSelector<RootState, SymbolLite[]>((state: RootState) => getFavoriteStocks(state));

  const onAddToFavouritesClick = (e) => {
    e?.stopPropagation();
    addToFavourites();
  };

  return (
    <>
      <div className={styles.wrapper}>
        <StockRow logo={logo} url={url} isMob stock={stock} closeModal={closeModal} />
        <div className={styles.favouritesBtn}>
          <AddToWatchlist
            onClick={onAddToFavouritesClick}
            isAdded={isSymbolInFavourites(favourites, stock.symbol)}
            isSearch
          />
        </div>
      </div>
    </>
  );
};

export default ResultRow;
